import { UnitsGridFormattingHelper } from '../../helpers/units-grid-formatting.helper';
import { UnitsGridColumn } from './units-grid-input.models';

export interface UnitsGridCompareColumnDefinition {
  readonly field: string;
  readonly header: string;
}

export function computeHeaderSelection(
  selectedColumns: readonly string[],
  field: string,
  multiSelect: boolean
): string[] {
  if (!multiSelect) {
    return [field];
  }

  const nextSelection = [...selectedColumns];
  const existingIndex = nextSelection.indexOf(field);
  if (existingIndex >= 0) {
    nextSelection.splice(existingIndex, 1);
  } else {
    nextSelection.push(field);
  }

  return nextSelection;
}

export function isHeaderSelected(selectedColumns: readonly string[], field: string): boolean {
  return selectedColumns.includes(field);
}

export function buildCompareColumnDefinitions(
  columns: readonly UnitsGridColumn[],
  getHeader: (column: UnitsGridColumn) => string
): UnitsGridCompareColumnDefinition[] {
  return columns.map((column) => ({
    field: column.field,
    header: getHeader(column)
  }));
}

export function buildSelectedColumnsClipboardText(args: {
  readonly columns: readonly UnitsGridColumn[];
  readonly selectedColumns: readonly string[];
  readonly rows: readonly Record<string, unknown>[];
  readonly getHeader: (column: UnitsGridColumn) => string;
}): string {
  const selectedFields = args.columns
    .filter((column) => args.selectedColumns.includes(column.field))
    .map((column) => column.field);

  if (selectedFields.length === 0) {
    return '';
  }

  const headers = args.columns
    .filter((column) => selectedFields.includes(column.field))
    .map((column) => args.getHeader(column));

  const rowData = args.rows.map((row) => selectedFields.map((field) => row[field] ?? ''));
  return UnitsGridFormattingHelper.buildTabDelimitedSelection(headers, rowData);
}

